import React, { Component } from "react";
import ProgressButton from "react-progress-button";
import PropTypes from "prop-types";
import { ContactService, ClientService } from "@services";
import utils from "@utils";
import { Modal } from "../../../../components";

import "./InviteClientModal.scss";

class InviteClientModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			buttonState: "",
			contactId: "",
			organizationFee: null,
			errors: {
				contactId: false,
			},
			contacts: [],
		};
	}

	componentDidMount() {
		const { clientId } = this.props;
		// TODO: Once the Location Modal refactor task (FE-926) has been merged, client contacts can be passed as a prop to this modal
		// and this service call can be removed
		if (clientId) {
			ContactService.getAll({ clientId })
				.then(({ data: { ItemList } }) => {
					const contacts = ItemList.map(item => ({
						value: item.Id,
						label: `${item.LastName}, ${item.FirstName}`,
						contactHasUser: item.ContactHasUser,
					}));
					this.setState({ contacts });
				})
				.catch(() => {});
		}
	}

	onEntered = () => {
		const { organizationFee: propsFee } = this.props;
		const { organizationFee: stateFee } = this.state;
		// If opened by a coordinator, use the preset coordination fee for the client as the default value for this modal
		if (stateFee === "" && propsFee) this.setState({ organizationFee: propsFee });
		document.getElementById("coordFee").focus();
	};

	onExited = () => {
		const { organizationFee } = this.props;
		this.setState({
			contactId: "",
			organizationFee: organizationFee || null,
			buttonState: "",
			errors: { contactId: false },
		});
	};

	updateOrgFee = ({ target: { value } }) => {
		if (value.match(/^\d*\.?\d{0,2}$/g)) {
			this.setState({ organizationFee: value });
		}
	};

	/** Removes a trailing decimal point if the user forgot to remove it before moving away */
	cleanOrgFee = () => {
		const { organizationFee } = this.state;
		const len = organizationFee.length;
		if (len > 0 && organizationFee[len - 1] === ".")
			this.setState({ organizationFee: organizationFee.substr(0, len - 1) });
	};

	/** Change which contact should receive an invitation to create a RollKall account */
	changeContact = ({ target: { value } }) =>
		this.setState(prevState => ({
			contactId: value,
			errors: { ...prevState.errors, contactId: false },
		}));

	/** Invites a client contact to create a RollKall account */
	inviteClient = () => {
		const { lang } = global;
		const { contactId, organizationFee } = this.state;
		const { clientId, onSuccess } = this.props;
		const errors = {};
		errors.contactId = contactId === "";
		this.setState({ errors, buttonState: errors.contactId ? "error" : "loading" }, () => {
			if (errors.contactId) {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 750);
				return;
			}
			const form = {
				contactId,
				organizationFee: organizationFee || null,
				clientId,
			};

			ClientService.inviteClient(form)
				.then(() => {
					this.setState({ buttonState: "success" }, () => {
						setTimeout(() => {
							clearTimeout();
							this.setState({ buttonState: "" });
							onSuccess();
						}, 750);
					});
				})
				.catch(() => {
					this.setState({ buttonState: "error" }, () => {
						utils.notify({
							type: "error",
							message: lang.t("Error inviting client"),
							timeOut: 1500,
						});
						setTimeout(() => {
							clearTimeout();
							this.setState({ buttonState: "" });
						}, 750);
					});
				});
		});
	};

	render() {
		const { lang } = global;
		const { buttonState, contactId, organizationFee, errors, contacts } = this.state;
		const { show, onHide } = this.props;
		return (
			<Modal
				show={show}
				id="invite-client-modal"
				onEntered={this.onEntered}
				onHide={onHide}
				onExited={this.onExited}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Invite to RollKall")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<p className="col-sm-12">
							{lang.t("Coordination fee will be added to the hourly officer rate_")}
							&nbsp;
							{lang.t(
								"Please note that the rate entered will be shared with the client on the invitation as well as all invoices_",
							)}
						</p>
					</div>
					<div className="row form-group">
						<div className="col-sm-4">
							<label htmlFor="coordFee">{lang.t("Coordination Fee")}</label>
							<input
								type="tel"
								name="coordFee"
								id="coordFee"
								className="form-control"
								value={organizationFee}
								onChange={this.updateOrgFee}
								onBlur={this.cleanOrgFee}
								placeholder="0"
							/>
						</div>
					</div>
					<div className="row form-group">
						<div className="col-sm-8">
							<label
								htmlFor="contactList"
								className={errors.contactId ? "text-danger" : ""}
							>
								{lang.t("Contact to Invite")}
							</label>
							<select
								name="contactList"
								id="contactList"
								className={`form-control ${errors.contactId ? "has-error" : ""}`}
								value={contactId}
								onChange={this.changeContact}
							>
								<option value="">--</option>
								<For
									each="contact"
									of={contacts}
								>
									<option
										className={
											contact.contactHasUser ? "option grayed-out" : ""
										}
										key={`clientcontact${contact.contactId}`}
										value={contact.value}
										disabled={contact.contactHasUser}
									>
										{contact.label}
									</option>
								</For>
							</select>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={onHide}
					>
						{lang.t("Cancel")}
					</button>
					<ProgressButton
						className="btn btn-primary"
						state={buttonState}
						onClick={this.inviteClient}
					>
						{lang.t("Invite")}
					</ProgressButton>
				</Modal.Footer>
			</Modal>
		);
	}
}

InviteClientModal.propTypes = {
	clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	show: PropTypes.bool,
	organizationFee: PropTypes.number,
	onHide: PropTypes.func,
	onSuccess: PropTypes.func,
};

InviteClientModal.defaultProps = {
	clientId: undefined,
	show: false,
	organizationFee: undefined,
	onHide: () => {},
	onSuccess: () => {},
};

export default InviteClientModal;
